import CampaignsController from './campaigns.controller';
import CampaignDetailController from './campaignDetail.controller';
import CampaignAddController from './campaignAdd.controller';
import CampaignContactDetailController from './campaignContactDetail.controller';
import MotherCampaignAddController from './motherCampaignAdd.controller';

export default angular
    .module('advinda.campaigns.controllers', [])
    .controller('CampaignsController', CampaignsController)
    .controller('CampaignDetailController', CampaignDetailController)
    .controller('CampaignAddController', CampaignAddController)
    .controller('motherCampaignAddController', MotherCampaignAddController)
    .controller('CampaignContactDetailController', CampaignContactDetailController);


/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaigns.controllers.js
 **/